import React from "react";
import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import AccountStatusComp from "../../../components/usersettings/accountstatuscomp";

export default function AccountStatus() {
  return (
    <>
      <UserProfileLayout>
        <div className="w-full bg-white rounded-2xl border border-primary50 justify-start gap-4 flex p-8 mb-4">
          <AccountStatusComp />
        </div>
      </UserProfileLayout>
    </>
  );
}
